import React from "react";
import {
  TextInput,
  SimpleForm,
  required,
  ReferenceInput,
  RadioButtonGroupInput,
  AutocompleteInput,
  Button,
  TopToolbar,
  EditProps,
  BooleanInput,
  FormDataConsumer,
} from "react-admin";
import { Grid, Typography } from "@material-ui/core";
import CustomImageInput from "components/CustomImageInput";
import SanitizedGrid from "components/SanitizedGrid";
import LevelInput from "components/LevelInput";
import LevelGroupInput from "components/LevelGroupInput";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { GetParam } from "utils/tools";
import CustomEditToolbar from "components/CustomEditToolbar";
import moment from "moment";
import CustomDatePickerInput from "components/CustomDatePickerInput";
import UniqueCodeInput from "./components/UniqueCodeInput";
import NameInput from "../../components/NameInput";
import { genderList } from "./const";
import CustomNumberInput from "../../components/CustomNumberInput";
import EditWrapper from "../../components/EditWrapper";

const StudentEdit = (props: EditProps) => {
  const param = GetParam();
  const { id } = props;

  let breadcrumbValue = [{ link: "", title: "", params: "" }];
  let redirectOnSuccess = {};

  if (param.get("parentId")) {
    breadcrumbValue = [
      {
        title: "Parents",
        link: `/parents/${param.get("parentId")}/show`,
        params: "",
      },
      {
        title: "Students",
        link: `/students/${id}/show`,
        params: `?parentId=${param.get("parentId")}`,
      },
      {
        title: id,
        link: "",
        params: "",
      },
    ];

    redirectOnSuccess = {
      saveLink: `/students/${id}/show?parentId=${param.get("parentId")}`,
      deleteLink: `/parents/${param.get("parentId")}/show/2`,
    };
  } else {
    breadcrumbValue = [
      {
        title: "Students",
        link: `/students/${id}/show`,
        params: "",
      },
      {
        title: id,
        link: "",
        params: "",
      },
    ];

    redirectOnSuccess = {
      saveLink: `/students/${id}/show`,
      deleteLink: `/students`,
    };
  }

  const breadcrumb = breadcrumbValue;

  const transform = async (data: any) => {
    if (data.photoUrl) {
      if (data.photoUrl.url) {
        data.photoUrl = (data.photoUrl.url as string).split(",")[1];

        delete data.photoUrlFile;
      }
    } else {
      data.photoUrl = null;
    }

    return data;
  };

  const EditActions = (props: any) => {
    const { history } = props;
    return (
      <TopToolbar>
        <Button
          onClick={() =>
            history.push(
              `/students/${props.data?.id}/show${
                param.get("parentId")
                  ? `?parentId=${param.get("parentId")}`
                  : ""
              }`
            )
          }
          label="Show"
        >
          <VisibilityIcon />
        </Button>
      </TopToolbar>
    );
  };

  return (
    <>
      <EditWrapper
        breadcrumb={breadcrumb}
        isFullName
        transform={transform}
        actions={<EditActions history={props.history} />}
        {...props}
      >
        <SimpleForm
          toolbar={
            <CustomEditToolbar
              redirectLink={redirectOnSuccess}
              isShowDelete={false}
            />
          }
        >
          <SanitizedGrid container spacing={2}>
            {/* <Grid item xs={12}>
              <Typography variant="h6">Parent</Typography>
            </Grid>

            <Grid item xs={3}>
              <ReferenceInput
                label="Name"
                source="parentId"
                reference="parents"
                disabled
              >
                <SelectInput
                  optionText={(choice: any) =>
                    `${choice.firstName} ${choice.lastName}`
                  }
                />
              </ReferenceInput>
            </Grid> */}

            <Grid item xs={12}>
              <Typography variant="h6">Student Details</Typography>
            </Grid>

            <Grid item xs={5}>
              <CustomImageInput
                label="Avatar"
                source="photoUrl"
                fieldType="image"
                accept="image/*"
                placeholder="Drop a images (*.jpg/jpeg/png) to upload, or click to select it."
              />
            </Grid>
            <Grid item xs={7}></Grid>

            <Grid item xs={4}>
              <RadioButtonGroupInput
                source="gender"
                choices={genderList}
                validate={required()}
              />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={4}>
              <UniqueCodeInput />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={4}>
              <NameInput label="First Name" source="firstName" />
            </Grid>

            <Grid item xs={4}>
              <NameInput label="Last Name" source="lastName" />
            </Grid>
            <Grid item xs={4}></Grid>

            <Grid item xs={4}>
              <CustomDatePickerInput
                name="dateOfBirth"
                label="Date of Birth *"
                max={moment().format("Y-MM-DD")}
              />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={4}>
              <TextInput label="Medical Condition" source="medicalCondition" />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={4}>
              <FormDataConsumer>
                {({ formData }) => {
                  if (formData.schoolId === 6) {
                    return (
                      <CustomNumberInput
                        source="externalId"
                        label="External id"
                      />
                    );
                  }

                  return <TextInput label="External id" source="externalId" />;
                }}
              </FormDataConsumer>
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={3}>
              <TextInput label="MAC Address" source="macAddress" />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={12}>
              <Typography variant="h6">School Details</Typography>
            </Grid>

            <Grid item xs={4}>
              <ReferenceInput
                label="School"
                source="schoolId"
                reference="schools"
                validate={required()}
              >
                <AutocompleteInput optionText="name" />
              </ReferenceInput>
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={4}>
              <LevelInput />
            </Grid>

            <Grid item xs={4}>
              <LevelGroupInput />
            </Grid>
            <Grid item xs={4}></Grid>

            <Grid item xs={4}>
              <BooleanInput
                label="Require Guardian at Drop Off"
                source="dropOffAuth"
              />
            </Grid>
            <Grid item xs={8}></Grid>
          </SanitizedGrid>
        </SimpleForm>
      </EditWrapper>
    </>
  );
};

export default StudentEdit;
